import { Routes, Route } from "react-router-dom";
import Layout from "./layout/Layout";
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import SearchPage from "./pages/SearchPage";
import CartPage from "./pages/CartPage";
import OfferPage from "./pages/OfferPage";
import MenuItemDetails from "./pages/MenuItemDetails";
import OrderTracking from "./pages/OrderTracking";
import { CartProvider } from "./context/CartContext";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCart } from "./context/CartContext";

const TableSync = () => {
  const location = useLocation();
  const { setTableNo } = useCart();

  useEffect(() => {
    const match = location.pathname.match(/\/table\/(\d+)/);

    if (match) {
      const tableId = match[1];
      setTableNo(tableId);
      localStorage.setItem("tableNo", tableId);
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <CartProvider>
      <div className="app-wrapper">
        <Layout>
          <TableSync />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/table/:tableId" element={<Home />} />
            <Route path="/category" element={<CategoryPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/offers" element={<OfferPage />} />
            <Route path="/item/:id" element={<MenuItemDetails />} />
            <Route
              path="/order-tracking/:orderId"
              element={<OrderTracking />}
            />
          </Routes>
        </Layout>
      </div>
    </CartProvider>
  );
}

export default App;
